module.exports = __webpack_public_path__ + "static/media/shot  -01-mobile.08ee4838.webp";